import { render } from "./BasicLayout.vue?vue&type=template&id=6d3c0ef2"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"

import "./BasicLayout.vue?vue&type=style&index=0&id=6d3c0ef2&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__